import React, {useEffect, useState} from "react";

import {
    BabyButton,
    Button,
    GradientButton,
    InstantRakeback,
    RewardHorizontalV2,
    RewardsDropdown,
    TRewardActionType,
    useWindowSize,
    vipReloadTitles,
} from "@housebets/housebets-x-package";
import VipReload from "../../legacy/VipReload";
import {RewardSlider} from "../RewardSlider";

import {useRewardDropdownData} from "./hooks/useRewardDropdownData";
import {useRewardListData} from "../hooks/useRewardListData";
import { useIntl } from "react-intl";

export const RewardDropdown: React.FC = () => {
    const {$t} = useIntl();

    const {isOpen, setIsOpen, rewardStep, setRewardStep, onDashboardClick, showMessage} = useRewardDropdownData();
    const {
        isOpenModal2,
        setIsOpenModal2,
        ClaimData,
        id,
        setId,
        vipReloadModalOpen,
        setVipReloadModalOpen,
        receiveManualBonus,
        vipReloadData,
        claimHandler,
        level,
        isLevelUpClaimed,
        dropdownRewardList,
        isLoading,
    } = useRewardListData((showFirstScreen = true, closeMenu = false) => {
        showMessage(rewardStep as TRewardActionType);
        if (showFirstScreen) {
            setRewardStep("list");
            if (countAvaibleRewards - 1 === 0) {
                setIsOpen(false);
            } else {
                setTimeout(() => {
                    setIsOpenModal2(false);
                    setVipReloadModalOpen(false);
                    setIsOpen(true);
                }, 200);
            }
        }
    });
    const {isMobile, isTablet} = useWindowSize();

    const countAvaibleRewards = dropdownRewardList.reduce((count, item) => {
        if (item?.notAvailable) return count;

        const aviable = (item as any).aviable === true;
        const canClaim = item.canClaim === true;
        const canDisplay = aviable || canClaim;

        let addCount = 0;

        switch (item.item_type) {
            case "instant_rakeback": // single
                if (canClaim && canDisplay) {
                    addCount = 1;
                }
                break;

            case "daily_reload": // single
                if (canClaim && canDisplay) {
                    addCount = 1;
                }
                break;

            case "weekly_reload":
                if (canClaim && level >= 7 && canDisplay) {
                    addCount = typeof (item as any)?.count === "number" ? (item as any).count : 1;
                }
                break;

            case "level_up":
                if ((canClaim || isLevelUpClaimed) && level >= 7 && canDisplay) {
                    addCount = 1;
                }
                break;

            case "vip_reload":
                if (canClaim && level >= 7 && canDisplay) {
                    addCount =
                        "manualBonusDataVoCount" in item && typeof (item as any).manualBonusDataVoCount === "number" ? (item as any).manualBonusDataVoCount : 1;
                }
                break;

            case "monthly_reload":
                if (canClaim && level >= 17 && canDisplay) {
                    addCount = typeof item.prepared === "number" ? item.prepared : 1;
                }
                break;
        }

        return count + addCount;
    }, 0);

    return (
        <RewardsDropdown.RDWrapper
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onClose={() => {
                // empty
            }}
            activeTabID={rewardStep === "list" ? "list" : "rakeback"}
            defaultTabID="list"
            trigger={
                <BabyButton.Vip
                    title="Vip"
                    kind={countAvaibleRewards > 0 ? "yellow" : "green2"}
                    count={countAvaibleRewards}
                    size={isMobile || isTablet ? "sm" : "md"}
                    isActive={isOpen}
                    onClick={() => {
                        setRewardStep("list");
                        setIsOpenModal2(false);
                        setVipReloadModalOpen(false);
                        setIsOpen(true);
                    }}
                />
            }
            tabs={[
                {
                    id: "list",
                    isRoot: true,
                    content: (
                        <>
                            <RewardsDropdown.RDHeader title={$t({id: "YourRewards"})} data-animate-fade />
                            <RewardsDropdown.RDContent>
                                <RewardsDropdown.RDList>
                                    {dropdownRewardList.map((item, i) => {
                                        return (
                                            <>
                                                {item.item_type === "instant_rakeback" && (
                                                    <RewardsDropdown.RDRow key={i} data-animate-fade>
                                                        <RewardHorizontalV2
                                                            id={i.toString()}
                                                            {...item}
                                                                   texts={{
                                                              signUpText: $t({id: "VipReload.signUpText"}), 
                                                              timerButtonText: $t({id: "VipReload.timerButtonText"}), 
                                                              claimed: $t({id: "VipReload.claimed"}),
                                                              claim: $t({id: "VipReload.claim"}),
                                                              notAvailable: $t({id: "VipReload.notAvailable"}),
                                                            }}
                                                            text={item.category}
                                                            onClick={() => {
                                                                item.onClick();
                                                                setRewardStep("instant_rakeback");
                                                            }}
                                                        />
                                                    </RewardsDropdown.RDRow>
                                                )}
                                                {item.item_type === "daily_reload" && (
                                                    <RewardsDropdown.RDRow key={i} data-animate-fade>
                                                        <RewardHorizontalV2
                                                            id={i.toString()}
                                                            text={item.category}
                                                            {...item}
                                                                   texts={{
                                                              signUpText: $t({id: "VipReload.signUpText"}), 
                                                              timerButtonText: $t({id: "VipReload.timerButtonText"}), 
                                                              claimed: $t({id: "VipReload.claimed"}),
                                                              claim: $t({id: "VipReload.claim"}),
                                                              notAvailable: $t({id: "VipReload.notAvailable"}),
                                                            }}
                                                            onClick={() => {
                                                                item.onClick();
                                                                setRewardStep("daily_reload");
                                                            }}
                                                        />
                                                    </RewardsDropdown.RDRow>
                                                )}
                                                {item.item_type === "weekly_reload" && level >= 7 && (
                                                    <RewardsDropdown.RDRow key={i} data-animate-fade>
                                                        <RewardHorizontalV2
                                                            id={i.toString()}
                                                            text={item.category}
                                                            {...item}
                                                                   texts={{
                                                              signUpText: $t({id: "VipReload.signUpText"}), 
                                                              timerButtonText: $t({id: "VipReload.timerButtonText"}), 
                                                              claimed: $t({id: "VipReload.claimed"}),
                                                              claim: $t({id: "VipReload.claim"}),
                                                              notAvailable: $t({id: "VipReload.notAvailable"}),
                                                            }}
                                                            // notAvailable={!item.notAvailable}
                                                            onClick={() => {
                                                                item.onClick();
                                                                setRewardStep("weekly_reload");
                                                            }}
                                                        />
                                                    </RewardsDropdown.RDRow>
                                                )}
                                                {item.item_type === "level_up" && level >= 7 && (item.canClaim || isLevelUpClaimed) && (
                                                    <RewardsDropdown.RDRow key={i} data-animate-fade>
                                                        <RewardHorizontalV2
                                                            id={i.toString()}
                                                            text={item.category}
                                                            {...item}
                                                                   texts={{
                                                              signUpText: $t({id: "VipReload.signUpText"}), 
                                                              timerButtonText: $t({id: "VipReload.timerButtonText"}), 
                                                              claimed: $t({id: "VipReload.claimed"}),
                                                              claim: $t({id: "VipReload.claim"}),
                                                              notAvailable: $t({id: "VipReload.notAvailable"}),
                                                            }}
                                                            onClick={() => {
                                                                item.onClick();
                                                                setRewardStep("level_up");
                                                            }}
                                                        />
                                                    </RewardsDropdown.RDRow>
                                                )}
                                                {item.item_type === "vip_reload" && item.canClaim && (
                                                    <RewardsDropdown.RDRow key={i} data-animate-fade>
                                                        <RewardHorizontalV2
                                                            id={i.toString()}
                                                            text={item.category}
                                                            {...item}
                                                            texts={{
                                                              signUpText: $t({id: "VipReload.signUpText"}), 
                                                              timerButtonText: $t({id: "VipReload.timerButtonText"}), 
                                                              claimed: $t({id: "VipReload.claimed"}),
                                                              claim: $t({id: "VipReload.claim"}),
                                                              notAvailable: $t({id: "VipReload.notAvailable"}),
                                                            }}
                                                            onClick={() => {
                                                                item.onClick();
                                                                setRewardStep("vip_reload");
                                                            }}
                                                        />
                                                    </RewardsDropdown.RDRow>
                                                )}
                                                {item.item_type === "monthly_reload" && level >= 17 && (
                                                    <RewardsDropdown.RDRow key={i} data-animate-fade>
                                                        <RewardHorizontalV2
                                                            id={i.toString()}
                                                            text={item.category}
                                                            {...item}
                                                                   texts={{
                                                              signUpText: $t({id: "VipReload.signUpText"}), 
                                                              timerButtonText: $t({id: "VipReload.timerButtonText"}), 
                                                              claimed: $t({id: "VipReload.claimed"}),
                                                              claim: $t({id: "VipReload.claim"}),
                                                              notAvailable: $t({id: "VipReload.notAvailable"}),
                                                            }}
                                                            onClick={() => {
                                                                item.onClick();
                                                                setRewardStep("monthly_reload");
                                                            }}
                                                        />
                                                    </RewardsDropdown.RDRow>
                                                )}
                                            </>
                                        );
                                    })}
                                </RewardsDropdown.RDList>
                                <RewardsDropdown.RDStatistic data-animate-fade>
                                    <RewardSlider simpleView />
                                </RewardsDropdown.RDStatistic>
                            </RewardsDropdown.RDContent>
                            <RewardsDropdown.RDFooter>
                                <GradientButton kind="fill" size="md" text={$t({id: "ViewDashboard"})} data-animate-fade onClick={onDashboardClick} />
                                <Button text={$t({id: "Close"})} size="medium-3" onClick={() => setIsOpen(false)} themeKind="clear" data-animate-fade />
                            </RewardsDropdown.RDFooter>
                        </>
                    ),
                },
                {
                    id: "rakeback",
                    isRoot: false,
                    content: (
                        <>
                            <RewardsDropdown.RDHeader
                                title={vipReloadTitles[rewardStep as TRewardActionType]}
                                onPrev={() => {
                                    setRewardStep("list");
                                    setTimeout(() => {
                                        setIsOpenModal2(false);
                                        setVipReloadModalOpen(false);
                                    }, 500);
                                }}
                                onClose={() => {
                                    setIsOpen(false);
                                }}
                                data-animate-fade
                            />
                            <RewardsDropdown.RDContent>
                                {isOpenModal2 && (
                                    <InstantRakeback
                                        texts={{
                                            emptyText: $t({id: "VipReload.emptyText"}),
                                            totalReward: $t({id: "VipReload.totalReward"}),
                                            claim: $t({id: "VipReload.claim"}),
                                        }}
                                        {...ClaimData}
                                        isLoading={isLoading}
                                        selectedCurrency={id}
                                        onCurrencyChange={(v) => setId(v)}
                                        onClick={claimHandler}
                                        v2
                                    />
                                )}
                                {vipReloadModalOpen && <VipReload isLoading={isLoading} {...vipReloadData} onClick={receiveManualBonus} />}
                            </RewardsDropdown.RDContent>
                        </>
                    ),
                },
            ]}
        />
    );
};

RewardDropdown.displayName = "RewardDropdown";
